import { Encounter, EncounterStatus } from "../types";
import { api } from "./api";

export const encountersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    acceptInvitation: builder.mutation<Encounter, { encounterId: number }>({
      query: ({ encounterId, ...body }) => ({
        url: `/api/encounters/${encounterId}/participants`,
        method: "POST",
        body,
      }),
    }),

    updateEncounter: builder.mutation<
      Encounter,
      { encounterId: number; status: EncounterStatus }
    >({
      query: ({ encounterId, ...body }) => ({
        url: `/api/encounters/${encounterId}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const { useAcceptInvitationMutation, useUpdateEncounterMutation } =
  encountersApi;
